import React from 'react';
import { TableContainer, Box, Paper, Table, TableCell, TableHead, TableRow, TableBody } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import useStyles from '../../../themes/makeStyles';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 10,
    },
}))(TableCell);

export default function ExpectedInventoryDetailTable(props) {
    const warehouseData =
        JSON.parse(sessionStorage.getItem("warehouseData")) || {};

    const classes = useStyles();

    return (
        <TableContainer component={Paper} className={classes.container}>
            <Table className={classes.table} aria-label="simple table" stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell colSpan={6} align="center">
                            <b>Expected Inventory Table </b>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>
                            <b>In-transit Stock</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Category</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>No of Items</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Value (Cr.)</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>{warehouseData.warehouse_name.includes('Pravesh') ? "Qty (NOs)" : "Qty (MT)"}</b>
                        </StyledTableCell>
                        <StyledTableCell>
                            <b>Space Occupied (Sq Ft.)</b>
                        </StyledTableCell>
                    </TableRow>
                </TableHead>


                {(props && props.expectedInventoryDetailData && props.expectedInventoryDetailData.length > 0) ?

                    props.expectedInventoryDetailData.map((each, index) => {

                        return (
                            <TableBody key={index}>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                        <div>
                                            <b> {'In-transit Stock'} </b>
                                        </div>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        <div>
                                            <b> {each.material_category ? each.material_category : '-'} </b>
                                        </div>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        <div>
                                            <b> {each.no_of_items ? each.no_of_items : 0} </b>
                                        </div>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        <div>
                                            <b> {each.value_in_cr ? each.value_in_cr : 0} </b>
                                        </div>
                                    </TableCell>
                                    {warehouseData.warehouse_name.includes('Pravesh') ? <TableCell component="th" scope="row">
                                        <div>
                                            <b> {each.unloading_quantity ? each.unloading_quantity : 0} </b>
                                        </div>
                                    </TableCell> :
                                        <TableCell component="th" scope="row">
                                            <div>
                                                <b> {each.gross_weight ? each.gross_weight : 0} </b>
                                            </div>
                                        </TableCell>}
                                    <TableCell component="th" scope="row">
                                        <div>
                                            <b> {each.bin_space_allocated ? each.bin_space_allocated : 0} </b>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>

                        )
                    }
                    ) : <TableBody><TableRow><b> No Expected Inventory Data </b> </TableRow></TableBody>}

            </Table>
        </TableContainer>
    );
} 